import React, { useEffect, useState } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { useDispatch } from 'react-redux'
import { isMobileSafari } from 'react-device-detect'

import LoadingAnimation from './LoadingAnimation'
import Paginator from 'components/Paginator'
import DoorCard from '../door/DoorCard'
import * as Scroll from 'react-scroll'
import { AxiosResponse } from 'axios'
import { Doors, Door } from 'apis/response_types'
import { logger } from 'utils/logger'
import loadingModules from 'modules/loading'
import { useHistory, useLocation } from 'react-router-dom'
import { getDoor } from 'apis/doors'

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiPaginationItem-root': {
      'font-size': '15px'
    },
    '& .MuiPagination-ul': {
      'justify-content': 'center'
    },
    '& .Mui-selected': {
      color: 'white',
      'background-color': '#11B5F4'
    },
    '& .Mui-selected:hover': {
      'background-color': '#11B5F4'
    }
  }
}))

interface Props {
  title: string
  description?: string
  textAlign?: 'left' | 'center'
  errorMessage?: string
  listAPI: (page: number, keyword?: string) => Promise<AxiosResponse<Doors>>
  keyword?: string
}

DoorList.defaultProps = {
  textAlign: 'center',
  errorMessage: 'サロンが見つかりませんでした',
  listAPI: (_: number) => {
    return Promise.resolve({
      doors: [],
      page: { total: 1, current: 1 }
    })
  }
}

type SearchParam = { [key: string]: any }

const defaultParams = {
  page: 1
}

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

export default function DoorList(props: Props) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const [doors, setDoors] = useState<Array<Door>>([])
  const [loading, setLoading] = useState(true)
  const location = useLocation()

  const query = useQuery()
  const history = useHistory()
  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(
    query.get('page') ? Number(query.get('page')) : 1
  )

  const getDoors = async () => {
    try {
      dispatch(loadingModules.actions.start())
      const res =
        props.keyword !== undefined
          ? await props.listAPI(currentPage, props.keyword)
          : await props.listAPI(currentPage)
      const data = res.data
      setDoors(data.doors)
      setTotalPage(data.total_pages)
    } catch (error) {
      logger.debug(error)
    } finally {
      setLoading(false)
      dispatch(loadingModules.actions.stop())
    }
  }

  useEffect(() => {
    getDoors()
  }, [currentPage, props.keyword])

  const changePage = (page: number) => {
    setLoading(true)
    setCurrentPage(page)
    const params = generateQueryString({
      page: page
    })
    history.push(`${location.pathname}?${params}`)
  }

  const generateQueryString = (query: any) => {
    const keys = Object.keys(query)
    return keys
      .filter((key: string) => {
        if (['hasImage', 'hasVideo'].includes(key)) {
          return query[key] !== false
        } else {
          return query[key] !== ''
        }
      })
      .map((key) => `${key}=${encodeURIComponent(query[key])}`)
      .join('&')
  }

  return (
    <React.Fragment>
      <div
        className={`section-base section-recommend -top ${
          isMobileSafari ? '' : 'pt30'
        }`}
        id="a-recommend"
      >
        <div className="section-inner">
          <h2 className="section-title" style={{ textAlign: props.textAlign }}>
            {props.title}
          </h2>
          {props.description && (
            <p
              className="description"
              style={{ textAlign: props.textAlign, paddingBottom: '20px' }}
            >
              {props.description}
            </p>
          )}
          {loading ? (
            <LoadingAnimation />
          ) : doors.length ? (
            <div>
              <ul className="list-recommend">
                {doors.map((door) => (
                  <DoorCard key={door.id} door={door} />
                ))}
              </ul>
              <Paginator
                page={currentPage}
                onChange={(event: any, page: number) => {
                  changePage(page)
                }}
                count={totalPage}
              />
            </div>
          ) : (
            <div className="section-base section-keyword -notFound">
              <div className="section-inner">
                <p>{props.errorMessage}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}
